import dayjs from '../../utils/dayjs';
import { DataTable, EmptyState, Page, Text, Link, Card, Button, BlockStack, InlineStack, Grid, Icon } from '@shopify/polaris';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import emptyIMG from '../../media/images/empty.png';
import Pagination from '../../components/pagination';
import helpers from '../../helpers';

import SkeletonLoading from 'components/skeletonPageLoading';
import SimpleFilter from 'components/simpleFilter';
import { ___ } from 'languages/index';
import { TypedPromotion, useDownloadPromotion, useGetPromotions, useMutateClonePromotion, useMutateDeletePromotion } from 'queries/promotion.query';
import { Helmet } from 'react-helmet-async';
import { DeleteIcon, DuplicateIcon, PageDownIcon, PlayCircleIcon, PlayIcon, PlusIcon, StarFilledIcon, StopCircleIcon } from '@shopify/polaris-icons';
import { useDeleteConfirm } from 'context/DeleteConfirmContext';
import PromotionModal from './promotion.modal';
import { useNotification } from 'context/NotificationContext';

import animation_video_thumbnail from 'media/lottie_files/Cut_Video_Thumbnail.json';
import Lottie from 'lottie-react';

export default function PickupTimeRule() {
  const [entities, setEntities] = useState<TypedPromotion[]>([]);
  const [totalItems, setTotalItems] = useState(0);

  const { addNotification } = useNotification();

  const history = useNavigate();

  /**
   * If user apply filter, it will add to URL, then parse URL back to initial state
   */
  let { search } = useLocation();
  let StringQuery: any = helpers.ExtractUrl(search);

  const initialQuery = {
    query: '',
    page: 1,
    limit: 25,
    sort: 'createdAt:desc',
  };
  const [mainQuery, setMainQuery] = useState({
    ...initialQuery,
    ...StringQuery,
  });

  const { data, refetch: getEntities, isPending: loading } = useGetPromotions(mainQuery);

  useEffect(() => {
    if (data) {
      setEntities(data.body);
      setTotalItems(data.totalItems);
    }
  }, [data]);

  /**
   * Change page number
   */
  const onChangePagination = useCallback(
    (numPage: number, limit: number) => {
      setMainQuery({ ...mainQuery, page: numPage, limit: limit });
    },
    [mainQuery]
  );

  /**
   * Double request!
   */
  useEffect(() => {
    let buildURLSearch = helpers.buildEndUrl(mainQuery);
    if (search !== buildURLSearch) history('/promotion' + buildURLSearch);
    getEntities();
  }, [mainQuery]);

  /**
   * I do not know ...
   * Bug: In React, do NOT remove this code
   */
  const filterCallback = useCallback((_value: any) => {
    if (_value === false) {
      return setMainQuery(initialQuery);
    } else {
      setMainQuery((oldValue) => {
        return { ...oldValue, ..._value };
      });
    }
  }, []);

  /** Xóa */
  const { mutateAsync: deleteFn } = useMutateDeletePromotion();
  const { showDeleteConfirm } = useDeleteConfirm();
  const deleteCallback = useCallback(async (id) => {
    let askHim = await showDeleteConfirm('Bạn chắc chắn chứ?', 'Hành động này không thể hoàn tác, vùng này sẽ bị xóa khỏi cơ sở dữ liệu.');
    if (askHim) {
      try {
        await deleteFn(id);
      } catch (e) {}
    }
  }, []);

  /** Clone cho nó nhanh */
  const { mutateAsync: cloneFn } = useMutateClonePromotion();
  const cloneCallback = useCallback(async (promotion_id: any) => {
    //
    try {
      await cloneFn(promotion_id);
      addNotification('info', 'Đã sao chép lịch.');
    } catch (e) {}
  }, []);

  const [playVideoURL, setPlayVideoURL] = useState<string>(null);

  /** Phục vụ cho cái modal */
  const [newModelactive, setNewModelactive] = useState(false);
  const toggleNewActive = useCallback(() => setNewModelactive((active) => !active), []);
  const currentPromotionID = useRef(null);

  /** Tải về  */
  const { mutateAsync: downloadExcelForThisPromotion, isPending: downloadGenerating } = useDownloadPromotion();
  const generateDownloadLink = useCallback(
    async (promotionID: any) => {
      try {
        const blob = await downloadExcelForThisPromotion(promotionID);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');

        a.href = url;
        a.download = `promotion-${promotionID}.xlsx`;

        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      } catch (e) {}
    },
    [mainQuery]
  );

  const emptyData = (
    <EmptyState heading="Không có bản ghi!" image={emptyIMG}>
      <p>Oh, Không có gì ở đây. Hãy thử bỏ bộ lọc hoặc tạo mới.</p>
    </EmptyState>
  );

  const renderItem = (rule: TypedPromotion) => {
    const { id, promotion_name, promotion_video_link, promotion_schedule, event_type, journey, view_count } = rule;
    return [
      id,
      <Link
        key={id}
        onClick={() => {
          currentPromotionID.current = id;
          toggleNewActive();
        }}
      >
        <div style={{ minWidth: '150px' }}>{helpers.trimContentString(promotion_name)}</div>
      </Link>,
      journey?.journey_name || '-',
      event_type,
      promotion_schedule?.weekday || '-',
      <BlockStack>
        <Text as="p">{helpers.numberToTime(promotion_schedule.start_time)}</Text>
        <Text as="p">{helpers.numberToTime(promotion_schedule.end_time)}</Text>
      </BlockStack>,
      promotion_schedule?.start_date ? (
        <BlockStack>
          <Text as="p">{dayjs(new Date(promotion_schedule?.start_date)).format('DD-MM-YYYY')}</Text>
          <Text as="p">{dayjs(new Date(promotion_schedule?.end_date)).format('DD-MM-YYYY')}</Text>
        </BlockStack>
      ) : (
        '-'
      ),
      promotion_schedule?.special_date ? <Icon source={StarFilledIcon} /> : '-',
      view_count,
      <InlineStack gap="200">
        <Button icon={PageDownIcon} onClick={() => generateDownloadLink(id)} variant="monochromePlain"></Button>
        <Button icon={DeleteIcon} onClick={() => deleteCallback(id)} variant="monochromePlain"></Button>
        <Button icon={DuplicateIcon} onClick={() => cloneCallback(id)} variant="monochromePlain"></Button>
        <Button
          icon={PlayCircleIcon}
          onClick={() => {
            setPlayVideoURL(promotion_video_link);
          }}
          variant="monochromePlain"
        ></Button>
      </InlineStack>,
    ];
  };
  const PagesList =
    totalItems > 0 ? (
      <>
        <DataTable
          hoverable
          verticalAlign="middle"
          fixedFirstColumns={2}
          columnContentTypes={['text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text', 'text']}
          headings={['ID', 'Tên chiến dịch', 'Hành trình', 'Loại video', 'Thứ?', 'Khoảng giờ', 'Khoảng ngày', 'Ngày lễ?', 'Lượt yêu cầu', '-']}
          rows={entities?.map(renderItem)}
          hideScrollIndicator
          footerContent={___('Show page {display_page_number} of {total_record_number} results', {
            display_page_number: <Text as="strong">{mainQuery?.page || 1}</Text>,
            total_record_number: <Text as="strong">{totalItems}</Text>,
          })}
        />
      </>
    ) : (
      emptyData
    );

  const Actual_page = (
    <>
      <Helmet>
        <title>Danh sách Chiến dịch video quảng cáo</title>
      </Helmet>
      <Page
        fullWidth
        title="Chiến dịch video quảng cáo"
        subtitle="Các lịch phát video và quy tắc"
        primaryAction={{
          content: 'Thêm chiến dịch',
          disabled: false,
          icon: PlusIcon,
          onAction: toggleNewActive,
        }}
      >
        <Grid columns={{ sm: 3 }}>
          <Grid.Cell columnSpan={{ xs: 6, sm: 4, md: 4, lg: 8, xl: 8 }}>
            <Card padding="0">
              <SimpleFilter
                loading={loading}
                onCallback={filterCallback}
                options={[
                  {
                    label: 'ONBOARD',
                    value: 'ONBOARD',
                    field: 'event_type',
                  },
                  {
                    label: 'OFFBOARD',
                    value: 'OFFBOARD',
                    field: 'event_type',
                  },
                ]}
                sortField={[
                  {
                    label: 'Lượt xem',
                    field: 'view_count',
                  },
                ]}
              />
              {PagesList}
            </Card>
            <br />
            {totalItems > mainQuery.limit ? (
              <Pagination TotalRecord={totalItems} activeCurrentPage={mainQuery.page} pageSize={mainQuery.limit} onChange={onChangePagination} />
            ) : null}
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 6, sm: 2, md: 2, lg: 4, xl: 4 }}>
            <Card>
              <InlineStack align="start" blockAlign="center">
                <span>
                  <Icon source={PlayIcon} />
                </span>
                <p>Xem thử video</p>
              </InlineStack>
              <br />
              <BlockStack>
                {playVideoURL ? (
                  <BlockStack gap="400">
                    <video
                      src={playVideoURL}
                      controls
                      autoPlay
                      className="w-full rounded-2xl shadow-lg"
                      onEnded={() => setPlayVideoURL(null)} // 🔑 Bắt sự kiện kết thúc
                    />

                    <Button
                      icon={StopCircleIcon}
                      onClick={() => {
                        setPlayVideoURL(null);
                      }}
                    >
                      Stop video
                    </Button>
                  </BlockStack>
                ) : (
                  <BlockStack align="center" inlineAlign="center">
                    <div style={{ textAlign: 'center', maxHeight: '250px', width: 'auto' }}>
                      <Lottie animationData={animation_video_thumbnail} loop={0} style={{ width: 'auto', height: '100%' }} />
                    </div>
                    <Text as="p" tone="subdued">
                      Chọn video từ danh sách và xem trước tại đây!
                    </Text>
                  </BlockStack>
                )}
              </BlockStack>
            </Card>
          </Grid.Cell>
        </Grid>
      </Page>

      {
        <PromotionModal
          show={newModelactive}
          currentPromotionID={currentPromotionID.current}
          onClose={() => {
            currentPromotionID.current = null;
            setNewModelactive(false);
          }}
        />
      }
    </>
  );

  return <>{entities === null ? <SkeletonLoading /> : Actual_page}</>;
}

